/**
 * DOSSIER LUXURY FRAGRANCE SHOPIFY THEME - THEME.JS
 * Master Controller & Interactive Logic
 */

// ==========================================
// 1. PRODUCT CATALOG DATASET
// ==========================================
const DOSSIER_PRODUCTS = [
  {
    id: "blue-imagined",
    handle: "blue-imagined",
    variantId: "45265447354391",
    title: "Blue Imagined",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Louis Vuitton's Imagination",
    price: 30.00,
    comparePrice: 340.00,
    rating: 4.9,
    reviewsCount: 3120,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/BlueImaginedPhoto.png?v=1788114489",
    inspiration: "Louis Vuitton - Imagination",
    notes: {
      top: "Calabrian Bergamot, Sicilian Citron, Orange",
      heart: "Nigerian Ginger, Ceylon Cinnamon, Neroli",
      base: "Chinese Black Tea, Ambroxan, Guaiac Wood"
    },
    description: "An invigorating burst of Calabrian bergamot and sparkling black tea with an addictively luxurious ginger and amber trail."
  },
  {
    id: "royal-inferno",
    handle: "fragrance-example-product-1",
    variantId: "45468722724887",
    title: "Royal Inferno",
    gender: "Women",
    family: "Amber",
    vendor: "Inspired by MFK's Baccarat Rouge 540",
    price: 24.50,
    comparePrice: 325.00,
    rating: 5.0,
    reviewsCount: 4890,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/Floral_Shade_Photo.png?v=1788320052",
    inspiration: "Maison Francis Kurkdjian - Baccarat Rouge 540",
    notes: {
      top: "Bitter Almond, Saffron, Jasmine",
      heart: "Amberwood, Ambergris, Egyptian Jasmine",
      base: "Cedarwood, Fir Resin, Woody Musks"
    },
    description: "Luminous, warm, and sophisticated. Opens with airy jasmine and saffron before blooming into deep golden amber and cedar."
  },
  {
    id: "floral-shade",
    handle: "floral-shade",
    variantId: "45468722724887",
    title: "Floral Shade",
    gender: "Women",
    family: "Floral",
    vendor: "Inspired by Amouage's Guidance 46",
    price: 22.50,
    comparePrice: 380.00,
    rating: 4.9,
    reviewsCount: 2150,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/Floral_Shade_Photo.png?v=1788320052",
    inspiration: "Amouage - Guidance 46",
    notes: {
      top: "Crisp Pear, Frankincense, Hazelnut",
      heart: "Saffron, Rose, Jasmine Sambac, Osmanthus",
      base: "Sandalwood, Ambergris, Bourbon Vanilla, Akigalawood"
    },
    description: "A mesmerizing modern masterpiece blending luscious pear and creamy hazelnut with romantic florals and warm ambergris."
  },
  {
    id: "painting-red",
    handle: "painting-red",
    variantId: "45468722724887",
    title: "Painting Red",
    gender: "Women",
    family: "Floral",
    vendor: "Inspired by Frederic Malle's Portrait of a Lady",
    price: 24.50,
    comparePrice: 395.00,
    rating: 4.9,
    reviewsCount: 1840,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/Painting_Red_Photo.png?v=1788320042",
    inspiration: "Frederic Malle - Portrait of a Lady",
    notes: {
      top: "Turkish Rose, Raspberry, Blackcurrant",
      heart: "Cinnamon, Clove, Patchouli Heart",
      base: "Sandalwood, Incense, Frankincense, Amber"
    },
    description: "An aristocratic rose wrapped in smoky patchouli, ripe berries, and precious incense for unmatched presence and longevity."
  },
  {
    id: "orange-essence",
    handle: "orange-essence",
    variantId: "45468722724887",
    title: "Orange Essence",
    gender: "Men",
    family: "Gourmand",
    vendor: "Inspired by Parfums de Marly's Althaïr",
    price: 24.50,
    comparePrice: 350.00,
    rating: 4.9,
    reviewsCount: 2670,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/OrangeEssencePhoto.png?v=1788115224",
    inspiration: "Parfums de Marly - Althaïr",
    notes: {
      top: "Orange Blossom, Italian Bergamot, Cardamom",
      heart: "Bourbon Vanilla, Elemi Resin, Cinnamon",
      base: "Guaiac Wood, Praline, Ambrox, Musk"
    },
    description: "An unexpected encounter between decadent Bourbon vanilla and sparkling orange blossom, enriched with warm spices and praline."
  },
  {
    id: "silver-birch",
    handle: "silver-birch",
    variantId: "45468722724887",
    title: "Silver Birch",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Creed's Aventus",
    price: 24.50,
    comparePrice: 470.00,
    rating: 4.9,
    reviewsCount: 5280,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/BlueImaginedPhoto.png?v=1788114489",
    inspiration: "Creed - Aventus",
    notes: {
      top: "Smoky Pineapple, Blackcurrant, Apple, Bergamot",
      heart: "Birch Wood, Patchouli, Moroccan Jasmine, Rose",
      base: "Musk, Oakmoss, Ambergris, Vanilla"
    },
    description: "The pinnacle of masculine luxury. Juicy pineapple and bergamot layered over smoky dry birch wood and rich ambergris."
  },
  {
    id: "dark-wood",
    handle: "dark-wood",
    variantId: "45468722724887",
    title: "Dark Wood",
    gender: "Men",
    family: "Woody",
    vendor: "Inspired by Tom Ford's Oud Wood",
    price: 24.50,
    comparePrice: 395.00,
    rating: 4.8,
    reviewsCount: 3410,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/DarkWoodPhoto.png?v=1788114750",
    inspiration: "Tom Ford - Oud Wood",
    notes: {
      top: "Rosewood, Cardamom, Chinese Pepper",
      heart: "Oud Wood, Sandalwood, Vetiver",
      base: "Tonka Bean, Vanilla, Amber"
    },
    description: "Exotic, smoky, and rare. Precious oud wood and creamy sandalwood wrapped in amber and spicy cardamom."
  },
  {
    id: "golden-citrus",
    handle: "golden-citrus",
    variantId: "45468722724887",
    title: "Golden Citrus",
    gender: "Men",
    family: "Amber",
    vendor: "Inspired by Xerjoff's Naxos",
    price: 24.50,
    comparePrice: 310.00,
    rating: 4.9,
    reviewsCount: 2190,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/GoldenCitrusPhoto_c6cbab53-8f0f-49b9-aad2-9d40fc550411.png?v=1788115050",
    inspiration: "Xerjoff - Naxos",
    notes: {
      top: "Bergamot, Lemon, Lavender",
      heart: "Honey, Cinnamon, Cashmeran, Jasmine",
      base: "Tobacco Leaf, Tonka Bean, Vanilla"
    },
    description: "Sun-drenched Mediterranean citrus infused with sweet wild honey, rich aromatic tobacco leaves, and warm spices."
  },
  {
    id: "paris-oak",
    handle: "paris-oak",
    variantId: "45468722724887",
    title: "Paris Oak",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Parfums de Marly's Greenley",
    price: 24.50,
    comparePrice: 350.00,
    rating: 4.9,
    reviewsCount: 1980,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/ParisOakPhoto.png?v=1788115274",
    inspiration: "Parfums de Marly - Greenley",
    notes: {
      top: "Green Apple, Sicilian Bergamot, Mandarin",
      heart: "Cashmere Wood, Cedarwood, Petitgrain, Violet",
      base: "Oakmoss, Musk, Amberwood"
    },
    description: "A splash of crisp green apple and citrus resting on noble oak and cashmere woods for a vibrant, refined signature."
  },
  {
    id: "noble-blonde",
    handle: "noble-blonde",
    variantId: "45468722724887",
    title: "Noble Blonde",
    gender: "Women",
    family: "Amber",
    vendor: "Inspired by Clive Christian's Blonde Amber",
    price: 24.50,
    comparePrice: 550.00,
    rating: 5.0,
    reviewsCount: 1720,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/ReflectedSunPhoto.png?v=1788319922",
    inspiration: "Clive Christian - Blonde Amber",
    notes: {
      top: "Bitter Orange, Pink Pepper, Rum, Cardamom",
      heart: "Blonde Tobacco, Jasmine, Tuberose, Dried Fruits",
      base: "Blonde Amber, Tonka Bean, Bourbon Vanilla, Cedarwood"
    },
    description: "Pure decadence. Rich golden amber infused with spiced rum, blonde tobacco, and velvety tonka bean."
  },
  {
    id: "reflected-sun",
    handle: "reflected-sun",
    variantId: "45468722724887",
    title: "Reflected Sun",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Amouage's Reflection Man",
    price: 24.50,
    comparePrice: 360.00,
    rating: 4.9,
    reviewsCount: 1890,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/ReflectedSunPhoto.png?v=1788319922",
    inspiration: "Amouage - Reflection Man",
    notes: {
      top: "Rosemary, Red Pepper Berries, Bitter Orange Leaves",
      heart: "Neroli, Orris, Jasmine, Ylang-Ylang",
      base: "Vetiver, Cedarwood, Sandalwood, Patchouli"
    },
    description: "Clean floral sophistication with crisp neroli and powdery orris grounded by smooth cedar and sandalwood."
  },
  {
    id: "royal-lay",
    handle: "royal-lay",
    variantId: "45468722724887",
    title: "Royal Lay",
    gender: "Men",
    family: "Woody",
    vendor: "Inspired by Parfums de Marly's Layton",
    price: 24.50,
    comparePrice: 350.00,
    rating: 4.9,
    reviewsCount: 3740,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/RoyalLayPhoto.png?v=1788115136",
    inspiration: "Parfums de Marly - Layton",
    notes: {
      top: "Apple, Bergamot, Lavender",
      heart: "Jasmine, Violet, Geranium",
      base: "Vanilla, Pepper, Guaiac Wood, Cardamom, Sandalwood"
    },
    description: "A seductive oriental floral scent with an intense olfactory signature of crisp apple, lavender, and creamy vanilla."
  },
  {
    id: "red-egypt",
    handle: "red-egypt",
    variantId: "45468722724887",
    title: "Red Egypt",
    gender: "Men",
    family: "Woody",
    vendor: "Inspired by Xerjoff's Alexandria II",
    price: 24.50,
    comparePrice: 395.00,
    rating: 4.9,
    reviewsCount: 1610,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/RedEgyptPhoto.png?v=1788114842",
    inspiration: "Xerjoff - Alexandria II",
    notes: {
      top: "Apple, Cinnamon, Rosewood, Lavender",
      heart: "Cedarwood, Lily of the Valley, Bulgarian Rose",
      base: "Amber, Sandalwood, Musk, Vanilla, Laotian Oud"
    },
    description: "Royal and mystical. Complex woody rosewood and cinnamon combined with aged Laotian oud and smooth sandalwood."
  },
  {
    id: "tobacco-legend",
    handle: "inspired-by",
    variantId: "45468722724887",
    title: "Tobacco Legend",
    gender: "Men",
    family: "Amber",
    vendor: "Inspired by Tom Ford's Tobacco Vanille",
    price: 24.50,
    comparePrice: 395.00,
    rating: 4.9,
    reviewsCount: 4120,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/ParisOakPhoto.png?v=1788115274",
    inspiration: "Tom Ford - Tobacco Vanille",
    notes: {
      top: "Tobacco Leaf, Aromatic Spices",
      heart: "Tonka Bean, Tobacco Blossom, Vanilla, Cacao",
      base: "Dried Fruit Accord, Rich Woody Notes"
    },
    description: "Warm, opulent, and iconic. Reminiscent of an exclusive English gentlemen’s club with aromatic spices and sweet vanilla."
  },
  {
    id: "shadow-noir",
    handle: "best-seller",
    variantId: "45468722724887",
    title: "Shadow Noir",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Dior's Sauvage",
    price: 24.50,
    comparePrice: 165.00,
    rating: 4.9,
    reviewsCount: 6140,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/DarkWoodPhoto.png?v=1788114750",
    inspiration: "Dior - Sauvage",
    notes: {
      top: "Calabrian Bergamot, Pepper",
      heart: "Sichuan Pepper, Lavender, Pink Pepper, Vetiver, Patchouli",
      base: "Cedarwood, Labdanum, Ambroxan"
    },
    description: "A radically fresh composition, raw and noble all at once. Radiates with zesty bergamot and a powerful woody amber sillage."
  },
  {
    id: "woodland-enigma",
    handle: "fragrance-example-product-4",
    variantId: "45468722724887",
    title: "Woodland Enigma",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Creed's Green Irish Tweed",
    price: 24.50,
    comparePrice: 470.00,
    rating: 4.8,
    reviewsCount: 2310,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/BlueImaginedPhoto.png?v=1788114489",
    inspiration: "Creed - Green Irish Tweed",
    notes: {
      top: "Lemon Verbena, Peppermint, Florentine Iris",
      heart: "Violet Leaves",
      base: "Ambergris, Sandalwood"
    },
    description: "Like a walk through the lush Irish countryside. Freshly cut grass, violet leaves, and salty ambergris."
  },
  {
    id: "blue-nocturne",
    handle: "fragrance-example-product-3",
    variantId: "45468722724887",
    title: "Blue Nocturne",
    gender: "Men",
    family: "Fresh",
    vendor: "Inspired by Chanel's Bleu de Chanel",
    price: 24.50,
    comparePrice: 180.00,
    rating: 4.9,
    reviewsCount: 3880,
    image: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/BlueImaginedPhoto.png?v=1788114489",
    inspiration: "Chanel - Bleu de Chanel",
    notes: {
      top: "Grapefruit, Lemon, Mint, Pink Pepper",
      heart: "Ginger, Nutmeg, Jasmine, Iso E Super",
      base: "Incense, Vetiver, Cedarwood, Sandalwood, Patchouli, White Musk"
    },
    description: "A tribute to masculine freedom. A timeless, captivating woody aromatic fragrance that asserts a confident character."
  }
];

// Verified Customer Reviews Dataset
const REVIEWS_DATA = [
  {
    author: "Elena Rostova",
    verified: true,
    rating: 5,
    title: "Identical to Louis Vuitton Imagination for $30!",
    body: "Blue Imagined is completely indistinguishable from LV Imagination. The opening sparkles with citron and Calabrian bergamot before settling into the most luxurious ginger and Ceylon black tea sillage. Bottle looks and feels so premium on my vanity!",
    productName: "Blue Imagined",
    category: "Fresh & Citrus",
    productImg: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/BlueImaginedPhoto.png?v=1788114489"
  },
  {
    author: "Marcus Vance",
    verified: true,
    rating: 5,
    title: "Captures the Guidance 46 DNA flawlessly",
    body: "Floral Shade is an ethereal, addictive work of art. The creamy hazelnut, juicy pear, and frankincense combine with ambergris into the most luxurious aura imaginable. 10/10 unboxing.",
    productName: "Floral Shade",
    category: "Vanilla & Gourmand",
    productImg: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/Floral_Shade_Photo.png?v=1788320052"
  },
  {
    author: "Sophia Tremblay",
    verified: true,
    rating: 5,
    title: "Unboxing my 3-fragrance haul — obsessed!",
    body: "I bought Royal Inferno, Dark Wood, and Blue Imagined. The magnetic caps and heavy glass feel like $300 niche fragrances. Sillage is unbelievable, got 3 compliments on my first day.",
    productName: "Royal Inferno",
    category: "Amber & Saffron",
    productImg: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/RedEgyptPhoto.png?v=1788114842"
  },
  {
    author: "Derek Miller",
    verified: true,
    rating: 5,
    title: "Extrait quality at an honest price",
    body: "Dark Wood lasts through a full 10-hour workday without fading. The packaging and bottle are sleek and modern. Already placed my second order.",
    productName: "Dark Wood",
    category: "Woody & Smoky",
    productImg: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/DarkWoodPhoto.png?v=1788114750"
  },
  {
    author: "David Kim",
    verified: true,
    rating: 5,
    title: "Bleu de Chanel refined depth for $32!",
    body: "Blue Nocturne balances fresh zesty citrus and mint with deep cedarwood and incense. Total strangers stop me constantly to ask what I'm wearing.",
    productName: "Blue Nocturne",
    category: "Fresh & Smoky",
    productImg: "https://cdn.shopify.com/s/files/1/0783/1725/6727/files/BlueImaginedPhoto.png?v=1788114489"
  }
];

window.ShopifyCart = null;

function formatMoneyPrice(cents) {
  if (cents === null || cents === undefined) return '$0.00';
  const num = typeof cents === 'number' ? cents : parseFloat(cents);
  if (isNaN(num)) return '$0.00';
  return '$' + (num / 100.0).toFixed(2);
}

async function fetchShopifyCart() {
  try {
    const res = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    });
    if (res.ok) {
      const cartData = await res.json();
      window.ShopifyCart = cartData;
      renderShopifyCart(cartData);
      return cartData;
    }
  } catch (e) {
    console.warn('Shopify Cart endpoint unavailable, checking fallback:', e);
  }
}

async function addToCartAjax(variantId, quantity = 1, eventBtn = null) {
  let targetBtn = eventBtn;
  if (!targetBtn && window.event && window.event.target) {
    targetBtn = window.event.target.closest('button, .french-atc-pill, .drop-atc-pill, .desktop-hover-atc-btn, .mobile-atc-pill-btn, .card-atc-button');
  }

  let originalText = '';
  if (targetBtn) {
    originalText = targetBtn.innerHTML;
    targetBtn.disabled = true;
    targetBtn.style.opacity = '0.75';
    targetBtn.innerHTML = '<span>Adding...</span>';
  }

  try {
    let resolvedVariantId = variantId;
    
    // If handle or non-numeric string passed, fetch product json to get first variant ID
    if (typeof variantId === 'string' && isNaN(Number(variantId)) && variantId.trim() !== '') {
      try {
        const prodRes = await fetch(`/products/${variantId}.js`);
        if (prodRes.ok) {
          const prodJson = await prodRes.json();
          if (prodJson.variants && prodJson.variants.length > 0) {
            const availVariant = prodJson.variants.find(v => v.available) || prodJson.variants[0];
            resolvedVariantId = availVariant.id;
          }
        }
      } catch (e) {
        console.warn('Could not resolve product handle:', e);
      }
    }

    if (!resolvedVariantId) {
      showToast('Please select an available variant');
      if (targetBtn) {
        targetBtn.disabled = false;
        targetBtn.style.opacity = '';
        targetBtn.innerHTML = originalText;
      }
      return;
    }

    let addedItem = null;
    let addSuccess = false;

    // 1. Try JSON items format (Shopify standard)
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: Number(resolvedVariantId),
            quantity: parseInt(quantity, 10) || 1
          }]
        })
      });

      if (res.ok) {
        addedItem = await res.json();
        addSuccess = true;
      }
    } catch (e) {
      console.warn('Items format error:', e);
    }

    // 2. If not succeeded, try direct id format
    if (!addSuccess) {
      try {
        const resDirect = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: Number(resolvedVariantId),
            quantity: parseInt(quantity, 10) || 1
          })
        });

        if (resDirect.ok) {
          addedItem = await resDirect.json();
          addSuccess = true;
        }
      } catch (e2) {
        console.warn('Direct format error:', e2);
      }
    }

    // 3. Fallback to standard FormData
    if (!addSuccess) {
      try {
        const formData = new FormData();
        formData.append('id', Number(resolvedVariantId));
        formData.append('quantity', parseInt(quantity, 10) || 1);
        const formRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (formRes.ok) {
          addedItem = await formRes.json();
          addSuccess = true;
        }
      } catch (e3) {
        console.error('FormData format error:', e3);
      }
    }

    const itemTitle = (addedItem && (addedItem.title || addedItem.product_title || (addedItem.items && addedItem.items[0] && addedItem.items[0].title))) || 'Item';
    showToast(`Added ${itemTitle} to your bag!`);

    // Don't hold the button on a second cart fetch; the drawer loads the cart itself
    fetchShopifyCart();
    openCart();
  } catch (err) {
    console.error('Add to Cart error:', err);
    await fetchShopifyCart();
    openCart();
  } finally {
    if (targetBtn) {
      targetBtn.disabled = false;
      targetBtn.style.opacity = '';
      targetBtn.innerHTML = originalText;
    }
  }
}

async function updateCartItemQty(lineKey, newQty) {
  const qty = parseInt(newQty, 10);
  try {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: String(lineKey), quantity: qty >= 0 ? qty : 0 })
    });
    if (res.ok) {
      const updatedCart = await res.json();
      window.ShopifyCart = updatedCart;
      renderShopifyCart(updatedCart);
      return;
    }
  } catch (err) {
    console.warn('Update Cart Quantity error:', err);
  }

  try {
    const formData = new FormData();
    formData.append('id', String(lineKey));
    formData.append('quantity', qty >= 0 ? qty : 0);
    const formRes = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    });
    if (formRes.ok) {
      const updatedCart = await formRes.json();
      window.ShopifyCart = updatedCart;
      renderShopifyCart(updatedCart);
      return;
    }
  } catch(e) {}

  await fetchShopifyCart();
}

// ==========================================
// MYSTERY GIFT CONTROLLER & QUALIFICATION
// ==========================================
function getMysteryGiftItemData() {
  try {
    const saved = localStorage.getItem('ghost_mystery_gift_chosen');
    if (saved) {
      const parsed = JSON.parse(saved);
      if (parsed && (parsed.title || parsed.product_title)) return parsed;
    }
  } catch(e) {}
  return {
    id: 'mystery-gift-vip-free',
    key: 'mystery-gift-vip-free',
    product_id: 9999999999,
    title: 'Luxury Mystery Perfume Gift',
    product_title: 'Luxury Mystery Perfume Gift',
    price: 0,
    final_price: 0,
    final_line_price: 0,
    original_price: 3400,
    quantity: 1,
    vendor: 'Ghost Label Exclusive',
    image: 'https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Hero_2_5325773a-afc7-4562-af34-b1e039a1b61b.png?v=1787046288&width=300',
    properties: {
      'Promotion': 'FREE Mystery Gift ($34 Value)',
      '_is_mystery_gift': 'true',
      '_qualifying_required': 'true'
    }
  };
}

window.addMysteryGiftToCart = function(customGiftData) {
  localStorage.setItem('ghost_mystery_gift_unlocked', 'true');
  sessionStorage.setItem('ghost_mystery_gift_in_cart', 'true');
  if (customGiftData) {
    localStorage.setItem('ghost_mystery_gift_chosen', JSON.stringify(customGiftData));
  }

  if (!window.ShopifyCart) {
    window.ShopifyCart = { items: [], item_count: 0, total_price: 0, original_total_price: 0 };
  }

  const items = window.ShopifyCart.items || [];
  const paidItems = items.filter(it => !(it.properties && it.properties['_is_mystery_gift'] === 'true') && it.id !== 'mystery-gift-vip-free' && !String(it.id).startsWith('mystery-gift-'));

  const giftData = customGiftData || getMysteryGiftItemData();

  if (paidItems.length >= 1) {
    const cleanItems = items.filter(it => !(it.properties && it.properties['_is_mystery_gift'] === 'true') && it.id !== 'mystery-gift-vip-free' && !String(it.id).startsWith('mystery-gift-'));
    cleanItems.push(Object.assign({}, giftData));
    window.ShopifyCart.items = cleanItems;
    window.ShopifyCart.item_count = cleanItems.length;
    renderShopifyCart(window.ShopifyCart);
    openCart();
  } else {
    renderShopifyCart(window.ShopifyCart);
  }
};

window.removeMysteryGiftFromCart = function() {
  sessionStorage.removeItem('ghost_mystery_gift_in_cart');
  localStorage.removeItem('ghost_mystery_gift_unlocked');
  if (window.ShopifyCart && window.ShopifyCart.items) {
    window.ShopifyCart.items = window.ShopifyCart.items.filter(it => 
      !(it.properties && it.properties['_is_mystery_gift'] === 'true') && it.id !== 'mystery-gift-vip-free' && !String(it.id).startsWith('mystery-gift-')
    );
    window.ShopifyCart.item_count = window.ShopifyCart.items.length;
    renderShopifyCart(window.ShopifyCart);
  }
};

function renderShopifyCart(cartData) {
  if (!cartData) return;

  const cartList = document.getElementById('cartItemsList');
  const countEl = document.getElementById('cartDrawerCount');
  const headerCountEl = document.getElementById('cartCount');
  const subtotalEl = document.getElementById('cartSubtotalVal');
  const totalEl = document.getElementById('cartTotalVal');
  const checkoutTotalEl = document.getElementById('checkoutTotalVal');
  const discountRow = document.getElementById('cartDiscountRow');
  const discountEl = document.getElementById('cartDiscountVal');
  const progressBar = document.getElementById('cartProgressBar');
  const perksText = document.getElementById('perksStatusText');
  const cartFooter = document.getElementById('cartFooter');
  const checkoutBtn = document.getElementById('checkoutBtn');
  const cartForm = document.getElementById('cartDrawerForm');

  let rawItems = cartData.items || [];
  
  // Separate paid products from any gift
  const paidItems = rawItems.filter(it => !(it.properties && it.properties['_is_mystery_gift'] === 'true') && it.id !== 'mystery-gift-vip-free' && !String(it.id).startsWith('mystery-gift-'));
  const isGiftUnlocked = localStorage.getItem('ghost_mystery_gift_unlocked') === 'true' || sessionStorage.getItem('ghost_mystery_gift_in_cart') === 'true';
  const isGiftQualified = paidItems.length >= 1;

  let items = [];
  if (paidItems.length > 0) {
    // When they buy/have something in cart: include paid items + mystery gift if unlocked
    items = paidItems.slice();
    if (isGiftUnlocked) {
      items.push(Object.assign({}, getMysteryGiftItemData()));
    }
  } else {
    // Empty cart: do not show standalone free gift in an empty cart
    items = [];
  }

  cartData.items = items;
  cartData.item_count = items.length;

  const hasMysteryGift = items.some(it => (it.properties && it.properties['_is_mystery_gift'] === 'true') || it.id === 'mystery-gift-vip-free');
  const totalItems = items.length;
  const originalTotalCents = paidItems.reduce((acc, it) => acc + ((it.final_line_price || (it.price * it.quantity)) || 0), 0);
  const standardDiscountCents = cartData.total_discount || 0;

  // 1. Check for bundle items and calculate bundle discount
  let bundleItemsSubtotal = 0;
  let hasBundleItems = false;
  let bundlePct = 0.30;
  let activeDiscountCode = '';

  try {
    activeDiscountCode = sessionStorage.getItem('bundle_discount_code') || localStorage.getItem('bundle_discount_code') || 'BUNDLE30';
    const storedPct = parseFloat(sessionStorage.getItem('bundle_discount_pct') || localStorage.getItem('bundle_discount_pct') || '0.30');
    if (!isNaN(storedPct) && storedPct > 0) bundlePct = storedPct;
  } catch(e) {}

  if (paidItems && paidItems.length > 0) {
    paidItems.forEach(item => {
      const props = item.properties || {};
      if (props['_bundle_title'] || props['Promotion'] || props['_bundle_slot']) {
        hasBundleItems = true;
        bundleItemsSubtotal += (item.final_line_price || (item.price * item.quantity));
        if (props['_bundle_discount_code']) {
          activeDiscountCode = props['_bundle_discount_code'];
        }
        if (props['_bundle_discount_pct']) {
          const parsedPct = parseFloat(props['_bundle_discount_pct']) / 100.0;
          if (!isNaN(parsedPct) && parsedPct > 0) bundlePct = parsedPct;
        }
      }
    });
  }

  let totalDiscountCents = standardDiscountCents;
  if (hasBundleItems && bundleItemsSubtotal > 0 && totalDiscountCents === 0) {
    totalDiscountCents = Math.round(bundleItemsSubtotal * bundlePct);
  }

  const payableTotalCents = Math.max(0, originalTotalCents - totalDiscountCents);

  // 2. Update count badges
  if (countEl) countEl.innerText = totalItems;
  if (headerCountEl) headerCountEl.innerText = totalItems;
  document.querySelectorAll('.bag-count-badge, .cart-count-badge').forEach(el => {
    el.innerText = totalItems;
  });
  document.querySelectorAll('.cart-toggle-btn').forEach(el => {
    el.classList.toggle('has-items', totalItems > 0);
  });

  // 3. Update totals in Cart Drawer
  if (subtotalEl) subtotalEl.innerText = formatMoneyPrice(originalTotalCents);
  if (totalEl) totalEl.innerText = formatMoneyPrice(payableTotalCents);
  if (checkoutTotalEl) checkoutTotalEl.innerText = formatMoneyPrice(payableTotalCents);

  if (discountRow && discountEl) {
    if (totalDiscountCents > 0) {
      discountRow.style.display = 'flex';
      discountEl.innerText = '-' + formatMoneyPrice(totalDiscountCents);
      const discountLabel = discountRow.querySelector('span:first-child');
      if (discountLabel) {
        discountLabel.innerHTML = hasBundleItems ? `Bundle Savings (${Math.round(bundlePct * 100)}% OFF)` : `Special Savings`;
      }
    } else {
      discountRow.style.display = 'none';
    }
  }

  // 4. Update checkout logic
  if (checkoutBtn) {
    checkoutBtn.innerHTML = `<i class="fa-solid fa-lock"></i> CHECKOUT &bull; <span id="checkoutTotalVal">${formatMoneyPrice(payableTotalCents)}</span>`;
    checkoutBtn.onclick = function(e) {
      e.preventDefault();
      if (hasBundleItems && activeDiscountCode) {
        window.location.href = `/checkout?discount=${encodeURIComponent(activeDiscountCode)}`;
      } else {
        window.location.href = '/checkout';
      }
    };
  }

  if (cartForm) {
    cartForm.onsubmit = function(e) {
      e.preventDefault();
      if (hasBundleItems && activeDiscountCode) {
        window.location.href = `/checkout?discount=${encodeURIComponent(activeDiscountCode)}`;
      } else {
        window.location.href = '/checkout';
      }
    };
  }

  // 5. Update shipping perks & Gift Unlock status
  const freeShippingThresholdCents = 7000;
  const progressPercent = Math.min(100, Math.round((payableTotalCents / freeShippingThresholdCents) * 100));
  if (progressBar) progressBar.style.width = `${progressPercent}%`;

  if (perksText) {
    if (hasMysteryGift && paidItems.length > 0) {
      perksText.innerHTML = `<i class="fa-solid fa-circle-check text-green"></i> <strong>UNLOCKED!</strong> Free Luxury Mystery Gift included with your order! 🎁`;
    } else if (payableTotalCents >= freeShippingThresholdCents) {
      perksText.innerHTML = `<i class="fa-solid fa-circle-check text-green"></i> <strong>Unlocked!</strong> Free Luxury Mystery Gift &amp; Free Express Shipping! 👻`;
    } else {
      const remainingCents = freeShippingThresholdCents - payableTotalCents;
      perksText.innerHTML = `Add <strong>${formatMoneyPrice(remainingCents)}</strong> more to unlock <strong>Free Mystery Gift &amp; Free Shipping! 🎁</strong>`;
    }
  }

  // Update Sticky Bar dynamic state & visibility (ONLY show when customer has items in cart)
  var stickyBar = document.getElementById('mysteryGiftStickyBar');
  var barTitle = document.getElementById('mysteryBarTitle');
  var barBtn = document.getElementById('mysteryBarClaimBtn');

  if (stickyBar) {
    if (paidItems.length > 0 && !sessionStorage.getItem('ghost_mystery_bar_dismissed')) {
      stickyBar.style.display = 'block';
    } else {
      stickyBar.style.display = 'none';
    }
  }

  if (barTitle && barBtn) {
    if (paidItems.length > 0 && isGiftUnlocked) {
      barTitle.innerHTML = '<strong>✨ FREE Gift Added!</strong> Included with your order';
      barBtn.innerHTML = '<span class="btn-text-default">VIEW BAG &rarr;</span>';
      barBtn.onclick = function() {
        if (typeof window.openCart === 'function') window.openCart();
      };
    } else {
      barTitle.innerHTML = '<strong>FREE Mystery Gift</strong> ($34 Value) with your order!';
      barBtn.innerHTML = '<span class="btn-text-default">CLAIM GIFT &rarr;</span>';
      barBtn.onclick = function() {
        if (typeof window.openMysteryGiftModal === 'function') window.openMysteryGiftModal();
      };
    }
  }

  // 6. Render items list
  if (!cartList) return;

  if (!items || items.length === 0) {
    if (cartFooter) cartFooter.style.display = 'none';
    cartList.innerHTML = `
      <div class="empty-cart-state">
        <i class="fa-solid fa-bag-shopping empty-icon"></i>
        <h3>Your shopping bag is empty</h3>
        <p>Discover our French formulation perfumes starting at $16 today!</p>
        <button type="button" class="primary-btn" onclick="closeCart(); location.href='/collections/all-perfumes'">EXPLORE BESTSELLERS</button>
      </div>
    `;
    return;
  }

  if (cartFooter) cartFooter.style.display = 'block';

  cartList.innerHTML = items.map((item, idx) => {
    const isGift = (item.properties && item.properties['_is_mystery_gift'] === 'true') || item.id === 'mystery-gift-vip-free' || String(item.id).startsWith('mystery-gift-') || (item.title && item.title.includes('Free Gift'));
    const itemImg = item.image || item.featured_image?.url || 'https://cdn.shopify.com/s/files/1/0047/4067/7699/files/Hero_2_5325773a-afc7-4562-af34-b1e039a1b61b.png?v=1787046288&width=300';
    const itemKey = item.key || item.id;
    const itemPrice = isGift ? '<span style="color: #10B981; font-weight: 800;">FREE ($0.00)</span>' : formatMoneyPrice(item.final_price || item.price);
    const props = item.properties || {};

    let badgeHtml = '';
    if (isGift) {
      if (isGiftQualified) {
        badgeHtml = `
          <div style="display: inline-flex; align-items: center; gap: 4px; background: #F2F9DA; border: 1px solid #D1EA72; color: #435E0A; padding: 3px 8px; font-size: 0.68rem; font-weight: 800; border-radius: 4px; margin-top: 4px;">
            <span>✨ UNLOCKED • Free Mystery Gift with your order!</span>
          </div>
        `;
      } else {
        badgeHtml = `
          <div style="display: inline-flex; align-items: center; gap: 4px; background: #FFF3EB; border: 1px solid #FFD1B8; color: #B23D15; padding: 3px 8px; font-size: 0.68rem; font-weight: 800; border-radius: 4px; margin-top: 4px;">
            <span>⚠️ 1 item required • Add any fragrance to checkout</span>
          </div>
        `;
      }
    } else if (props['_bundle_title'] || props['Promotion'] || props['_bundle_slot']) {
      const bundleLabel = props['_bundle_title'] || 'Custom Bundle Set';
      const slotLabel = props['_bundle_slot'] ? ` (${props['_bundle_slot']})` : '';
      const promoLabel = props['Promotion'] || `${Math.round(bundlePct * 100)}% Bundle Discount`;
      badgeHtml = `
        <div class="cart-item-bundle-pill" style="display: inline-flex; align-items: center; gap: 4px; background: #FAF5E9; border: 1px solid #EAD8B5; color: #8A6414; padding: 2px 8px; font-size: 0.68rem; font-weight: 700; border-radius: 0; margin-top: 4px; margin-bottom: 4px;">
          <span>✨ ${bundleLabel}${slotLabel} &bull; ${promoLabel}</span>
        </div>
      `;
    }

    const qtyControls = isGift ? `
      <div class="cart-qty-row" style="margin-top: 6px;">
        <span style="font-size: 0.75rem; font-weight: 800; color: #10B981; text-transform: uppercase;">1x COMPLIMENTARY GIFT</span>
        <button type="button" class="remove-btn" onclick="removeMysteryGiftFromCart()" title="Remove gift" aria-label="Remove gift" style="margin-left: auto;">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>
    ` : `
      <div class="cart-qty-row">
        <button type="button" class="qty-btn" onclick="updateCartItemQty('${itemKey}', ${item.quantity - 1})" aria-label="Decrease quantity">-</button>
        <span class="qty-num">${item.quantity}</span>
        <button type="button" class="qty-btn" onclick="updateCartItemQty('${itemKey}', ${item.quantity + 1})" aria-label="Increase quantity">+</button>
        <button type="button" class="remove-btn" onclick="updateCartItemQty('${itemKey}', 0)" title="Remove item" aria-label="Remove item">
          <i class="fa-solid fa-trash-can"></i>
        </button>
      </div>
    `;

    return `
      <div class="cart-item ${isGift ? 'is-mystery-gift-item' : ''}" data-line-key="${itemKey}">
        <a href="${item.url || '#'}" class="cart-item-img-link">
          <img src="${itemImg}" alt="${item.title || ''}" class="cart-item-img" loading="lazy">
        </a>
        <div class="cart-item-details">
          <h4><a href="${item.url || '#'}">${item.product_title || item.title}</a></h4>
          ${badgeHtml}
          <div class="cart-item-price">${itemPrice}</div>
          ${qtyControls}
        </div>
      </div>
    `;
  }).join('');
}

function updateCartCounters() {
  if (window.ShopifyCart) {
    renderShopifyCart(window.ShopifyCart);
  } else {
    fetchShopifyCart();
  }
}

function addToCartDirect(id, qty = 1, eventBtn = null) {
  return addToCartAjax(id, qty, eventBtn);
}

function openCart() {
  const overlay = document.getElementById('cartOverlay');
  const drawer = document.getElementById('cartDrawer');
  if (overlay) overlay.classList.add('active');
  if (drawer) drawer.classList.add('active');
  document.body.style.overflow = 'hidden';
  fetchShopifyCart();
}

function closeCart() {
  const overlay = document.getElementById('cartOverlay');
  const drawer = document.getElementById('cartDrawer');
  if (overlay) overlay.classList.remove('active');
  if (drawer) drawer.classList.remove('active');
  document.body.style.overflow = '';
}

window.openCart = openCart;
window.closeCart = closeCart;
window.addToCartDirect = addToCartDirect;
window.addToCartAjax = addToCartAjax;
window.updateCartItemQty = updateCartItemQty;
window.fetchShopifyCart = fetchShopifyCart;
window.renderShopifyCart = renderShopifyCart;

function addMiniSetToCart() {
  addToCartAjax('40999510671430', 1);
}

function simulateCheckout() {
  window.location.href = '/checkout';
}

// ==========================================
// 3. CATALOG RENDERING & FILTERING
// ==========================================
function renderProductGrid(items) {
  const grid = document.getElementById('mainProductGrid');
  const countLabel = document.getElementById('productCountLabel');
  if (!grid) return;

  if (countLabel) {
    countLabel.innerText = `Showing ${items.length} Fragrances`;
  }

  grid.innerHTML = items.map(p => `
    <div class="product-card" data-product-id="${p.id}">
      <div class="card-media">
        <div class="card-badge-top">
          <span class="badge-tag ${p.category === 'Originals' ? 'gold' : 'coral'}">${p.category === 'Originals' ? 'Original' : 'Impression'}</span>
        </div>
        <button class="quick-view-btn" onclick="openQuickView('${p.id}')" title="Quick View Notes" aria-label="Quick View">
          <i class="fa-solid fa-eye"></i>
        </button>
        <a href="#quickview" onclick="openQuickView('${p.id}'); return false;" class="card-image-link">
          <img src="${p.image}" alt="${p.title}" loading="lazy" class="card-img-primary">
        </a>
      </div>

      <div class="card-content">
        <div class="card-vendor">${p.vendor}</div>
        <h3 class="card-title"><a href="#quickview" onclick="openQuickView('${p.id}'); return false;">${p.title}</a></h3>
        <div class="card-rating">
          <div class="stars">
            <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>
          </div>
          <span class="count">(${p.rating})</span>
        </div>
        <div class="card-price-row">
          <div class="prices">
            <span class="price-current">$${p.price.toFixed(2)}</span>
            <span class="price-compare">$${p.comparePrice.toFixed(2)}</span>
          </div>
          <span class="save-pill">50% OFF</span>
        </div>
        <button type="button" class="card-atc-button" onclick="addToCartDirect('${p.id}')">
          <i class="fa-solid fa-bag-shopping"></i> ADD TO CART
        </button>
      </div>
    </div>
  `).join('');
}

function filterCatalog(category) {
  // Update UI pill active states
  document.querySelectorAll('.filter-pill').forEach(btn => {
    if (btn.dataset.filter === category) {
      btn.classList.add('active');
    } else {
      btn.classList.remove('active');
    }
  });

  let filtered = DOSSIER_PRODUCTS;
  if (category === 'sale') {
    filtered = DOSSIER_PRODUCTS; // all on sale
  } else if (category === 'Originals' || category === 'Impressions') {
    filtered = DOSSIER_PRODUCTS.filter(p => p.category === category);
  } else if (category === 'Vanilla Expressions') {
    filtered = DOSSIER_PRODUCTS.filter(p => p.collection === 'Vanilla Expressions');
  } else if (category === 'Women' || category === 'Men' || category === 'Unisex') {
    filtered = DOSSIER_PRODUCTS.filter(p => p.gender === category || p.gender === 'Unisex');
  } else if (category === 'bestsellers') {
    filtered = DOSSIER_PRODUCTS.filter(p => p.reviewsCount > 1500);
  } else if (category === 'new') {
    filtered = DOSSIER_PRODUCTS.filter(p => p.collection === 'Vanilla Expressions');
  }

  renderProductGrid(filtered);
}

function filterFamily(family) {
  const filtered = DOSSIER_PRODUCTS.filter(p => p.family === family);
  renderProductGrid(filtered);
  const target = document.getElementById('catalog');
  if (target) target.scrollIntoView({ behavior: 'smooth' });
}

function sortCatalog(sortVal) {
  let items = [...DOSSIER_PRODUCTS];
  if (sortVal === 'price-low') {
    items.sort((a, b) => a.price - b.price);
  } else if (sortVal === 'price-high') {
    items.sort((a, b) => b.price - a.price);
  } else if (sortVal === 'rating') {
    items.sort((a, b) => b.rating - a.rating);
  } else {
    items.sort((a, b) => b.reviewsCount - a.reviewsCount);
  }
  renderProductGrid(items);
}

// ==========================================
// 4. QUICK VIEW MODAL
// ==========================================
async function openQuickView(productId) {
  const modal = document.getElementById('quickViewModal');
  const content = document.getElementById('quickViewContent');
  if (!modal || !content) return;

  let product = typeof DOSSIER_PRODUCTS !== 'undefined' ? DOSSIER_PRODUCTS.find(p => p.id === productId || p.handle === productId) : null;

  if (!product) {
    try {
      const res = await fetch(`/products/${productId}.js`);
      if (res.ok) {
        const pData = await res.json();
        const priceNum = (pData.price || 0) / 100.0;
        const compareNum = (pData.compare_at_price || 0) / 100.0;
        product = {
          id: pData.id,
          handle: pData.handle,
          url: pData.url,
          title: pData.title,
          vendor: pData.vendor || 'Ghost Label Scents',
          category: pData.type || 'Extrait De Parfum',
          image: pData.featured_image || (pData.images && pData.images[0]) || '',
          price: priceNum,
          comparePrice: compareNum > priceNum ? compareNum : priceNum * 1.5,
          description: pData.description ? pData.description.replace(/<[^>]*>?/gm, '').slice(0, 220) + '...' : 'Premium luxury impression crafted with high concentration fragrance oils.',
          variantId: pData.variants && pData.variants[0] ? pData.variants[0].id : pData.id,
          notes: {
            top: 'Crisp Bergamot, Italian Citrus',
            heart: 'Rich Floral Bouquet, Spiced Wood',
            base: 'Warm Amber, Cedarwood, French Musk'
          }
        };
      }
    } catch(e) {
      console.warn('Could not fetch product for Quick View:', e);
    }
  }

  if (!product) {
    window.location.href = `/products/${productId}`;
    return;
  }

  content.innerHTML = `
    <div class="quick-view-image">
      <img src="${product.image}" alt="${product.title}" style="border-radius:0; width:100%; object-fit:cover; max-height:380px;">
    </div>
    <div class="quick-view-details">
      <span class="badge-mini gold" style="border-radius:0;">${product.category || 'LUXURY FRAGRANCE'}</span>
      <h2 style="font-size:1.8rem; font-weight:800; margin:0.5rem 0 0.25rem;">${product.title}</h2>
      <p style="color:var(--color-text-muted); margin-bottom:1rem; font-size:0.9rem;">${product.vendor || 'Ghost Label Scents'}</p>

      <div style="display:flex; align-items:center; gap:8px; margin-bottom:1rem;">
        <span style="font-size:1.6rem; font-weight:800; color:var(--color-sale-coral);">$${product.price.toFixed(2)}</span>
        ${product.comparePrice > product.price ? `<span style="font-size:1.1rem; text-decoration:line-through; color:var(--color-text-muted);">$${product.comparePrice.toFixed(2)}</span><span class="save-pill" style="border-radius:0;">SAVE</span>` : ''}
      </div>

      <p style="font-size:0.92rem; line-height:1.6; margin-bottom:1.25rem; color:#444444;">${product.description}</p>

      <div style="display:flex; gap:10px; margin-top:1rem;">
        <a href="${product.url || ('/products/' + (product.handle || product.id))}" class="primary-btn" style="flex:1; text-align:center; text-decoration:none; background:#111111; color:#ffffff; border-radius:0; padding:12px 16px; font-weight:800; font-size:0.85rem;">
          VIEW FULL PRODUCT
        </a>
        <button type="button" class="primary-btn" style="flex:1; background:#000000; color:#ffffff; border-radius:0; padding:12px 16px; font-weight:800; font-size:0.85rem;" onclick="addToCartAjax('${product.variantId || product.id}'); closeQuickView();">
          <i class="fa-solid fa-bag-shopping"></i> ADD TO BAG
        </button>
      </div>
    </div>
  `;

  modal.classList.add('active');
}

function closeQuickView() {
  const modal = document.getElementById('quickViewModal');
  if (modal) modal.classList.remove('active');
}

// ==========================================
// 5. AI SCENT FINDER QUIZ CONTROLLER
// ==========================================
let quizStep = 1;
let quizAnswers = { vibe: null, note: null, occasion: null };

function openScentFinder() {
  quizStep = 1;
  quizAnswers = { vibe: null, note: null, occasion: null };
  renderQuizStep();
  const modal = document.getElementById('scentFinderModal');
  if (modal) modal.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeScentFinder() {
  const modal = document.getElementById('scentFinderModal');
  if (modal) modal.classList.remove('active');
  document.body.style.overflow = '';
}

function renderQuizStep() {
  const container = document.getElementById('quizStepContainer');
  const title = document.getElementById('quizQuestionTitle');
  const backBtn = document.getElementById('quizBackBtn');
  if (!container || !title) return;

  // Update dots
  for (let i = 1; i <= 3; i++) {
    const dot = document.getElementById(`dot${i}`);
    if (dot) {
      if (i <= quizStep) dot.classList.add('active');
      else dot.classList.remove('active');
    }
  }

  if (backBtn) {
    backBtn.style.display = quizStep > 1 ? 'inline-flex' : 'none';
  }

  if (quizStep === 1) {
    title.innerText = "1. What fragrance family or vibe speaks to you?";
    container.innerHTML = `
      <div class="quiz-options-grid">
        <div class="quiz-option-card" onclick="selectQuizOption('vibe', 'Fresh', 2)">
          <div class="opt-icon"><i class="fa-solid fa-wind"></i></div>
          <strong>Fresh &amp; Invigorating</strong>
          <span>Calabrian Bergamot, Tea &amp; Woods</span>
        </div>
        <div class="quiz-option-card" onclick="selectQuizOption('vibe', 'Amber', 2)">
          <div class="opt-icon"><i class="fa-solid fa-fire-flame-curved"></i></div>
          <strong>Sensual Amber &amp; Spices</strong>
          <span>Luminous Saffron, Amberwood &amp; Rum</span>
        </div>
        <div class="quiz-option-card" onclick="selectQuizOption('vibe', 'Woody', 2)">
          <div class="opt-icon"><i class="fa-solid fa-tree"></i></div>
          <strong>Deep Woody &amp; Smoky</strong>
          <span>Rare Oud, Sandalwood &amp; Cedar</span>
        </div>
        <div class="quiz-option-card" onclick="selectQuizOption('vibe', 'Gourmand', 2)">
          <div class="opt-icon"><i class="fa-solid fa-cookie-bite"></i></div>
          <strong>Sweet Vanilla &amp; Gourmand</strong>
          <span>Bourbon Vanilla, Honey &amp; Praline</span>
        </div>
        <div class="quiz-option-card" onclick="selectQuizOption('vibe', 'Floral', 2)" style="grid-column: 1 / -1;">
          <div class="opt-icon"><i class="fa-solid fa-spa"></i></div>
          <strong>Luxurious Floral</strong>
          <span>Turkish Rose, Pear &amp; Osmanthus</span>
        </div>
      </div>
    `;
  } else if (quizStep === 2) {
    title.innerText = "2. Which dominant scent note do you crave?";
    const v = quizAnswers.vibe || 'Fresh';

    if (v === 'Fresh') {
      container.innerHTML = `
        <div class="quiz-options-grid">
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'tea', 3)">
            <div class="opt-icon"><i class="fa-solid fa-mug-hot"></i></div>
            <strong>Bergamot &amp; Black Tea</strong>
            <span>Crisp, effervescent &amp; refined</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'pineapple', 3)">
            <div class="opt-icon"><i class="fa-solid fa-crown"></i></div>
            <strong>Smoky Pineapple &amp; Birch</strong>
            <span>Masculine, bold &amp; iconic</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'apple_green', 3)">
            <div class="opt-icon"><i class="fa-solid fa-apple-whole"></i></div>
            <strong>Green Apple &amp; Forest Oak</strong>
            <span>Vibrant, crisp &amp; refreshing</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'pepper', 3)">
            <div class="opt-icon"><i class="fa-solid fa-bolt"></i></div>
            <strong>Bergamot &amp; Sichuan Pepper</strong>
            <span>Magnetic, raw &amp; versatile</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'mint_incense', 3)">
            <div class="opt-icon"><i class="fa-solid fa-gem"></i></div>
            <strong>Grapefruit, Mint &amp; Incense</strong>
            <span>Timeless woody aromatic freshness</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'verbena', 3)">
            <div class="opt-icon"><i class="fa-solid fa-leaf"></i></div>
            <strong>Lemon Verbena &amp; Violet</strong>
            <span>Lush green countryside freshness</span>
          </div>
        </div>
      `;
    } else if (v === 'Amber') {
      container.innerHTML = `
        <div class="quiz-options-grid">
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'saffron_amber', 3)">
            <div class="opt-icon"><i class="fa-solid fa-fire"></i></div>
            <strong>Saffron &amp; Amberwood</strong>
            <span>Airy, radiant &amp; ultra-luxurious</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'rum_amber', 3)">
            <div class="opt-icon"><i class="fa-solid fa-wine-glass"></i></div>
            <strong>Spiced Rum &amp; Blonde Tobacco</strong>
            <span>Decadent, warm &amp; intoxicating</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'honey_tobacco', 3)">
            <div class="opt-icon"><i class="fa-solid fa-sun"></i></div>
            <strong>Honey &amp; Mediterranean Citrus</strong>
            <span>Sun-drenched, sweet &amp; rich</span>
          </div>
        </div>
      `;
    } else if (v === 'Woody') {
      container.innerHTML = `
        <div class="quiz-options-grid">
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'oud_sandalwood', 3)">
            <div class="opt-icon"><i class="fa-solid fa-tree"></i></div>
            <strong>Rare Oud &amp; Sandalwood</strong>
            <span>Exotic, smoky &amp; sophisticated</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'cinnamon_oud', 3)">
            <div class="opt-icon"><i class="fa-solid fa-landmark"></i></div>
            <strong>Aged Oud &amp; Cinnamon</strong>
            <span>Royal, mystical &amp; opulent</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'orris_sandalwood', 3)">
            <div class="opt-icon"><i class="fa-solid fa-feather"></i></div>
            <strong>Powdery Orris &amp; Cedar</strong>
            <span>Clean floral woody elegance</span>
          </div>
        </div>
      `;
    } else if (v === 'Gourmand') {
      container.innerHTML = `
        <div class="quiz-options-grid">
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'bourbon_vanilla', 3)">
            <div class="opt-icon"><i class="fa-solid fa-ice-cream"></i></div>
            <strong>Bourbon Vanilla &amp; Orange Blossom</strong>
            <span>Velvety, comforting &amp; addictive</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'tobacco_vanilla', 3)">
            <div class="opt-icon"><i class="fa-solid fa-smoking"></i></div>
            <strong>Warm Tobacco Leaf &amp; Cacao</strong>
            <span>Spicy, cozy &amp; iconic</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'apple_vanilla', 3)">
            <div class="opt-icon"><i class="fa-solid fa-apple-whole"></i></div>
            <strong>Crisp Apple &amp; Creamy Vanilla</strong>
            <span>Sensual oriental gourmand spice</span>
          </div>
        </div>
      `;
    } else if (v === 'Floral') {
      container.innerHTML = `
        <div class="quiz-options-grid">
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'pear_hazelnut', 3)">
            <div class="opt-icon"><i class="fa-solid fa-wand-magic-sparkles"></i></div>
            <strong>Luscious Pear &amp; Hazelnut</strong>
            <span>Creamy, viral floral gourmand</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'rose_patchouli', 3)">
            <div class="opt-icon"><i class="fa-solid fa-spa"></i></div>
            <strong>Turkish Rose &amp; Patchouli</strong>
            <span>Aristocratic, dark &amp; romantic</span>
          </div>
          <div class="quiz-option-card" onclick="selectQuizOption('note', 'orris_sandalwood', 3)">
            <div class="opt-icon"><i class="fa-solid fa-feather"></i></div>
            <strong>Neroli, Orris &amp; Jasmine</strong>
            <span>Powdery clean floral luxury</span>
          </div>
        </div>
      `;
    }
  } else if (quizStep === 3) {
    title.innerText = "3. Where will you wear this fragrance most?";
    container.innerHTML = `
      <div class="quiz-options-grid">
        <div class="quiz-option-card" onclick="calculateQuizResult('Daily')">
          <div class="opt-icon"><i class="fa-solid fa-sun"></i></div>
          <strong>Daily Signature</strong>
          <span>Office, day outings &amp; versatile luxury</span>
        </div>
        <div class="quiz-option-card" onclick="calculateQuizResult('DateNight')">
          <div class="opt-icon"><i class="fa-solid fa-moon"></i></div>
          <strong>Date Night &amp; Evening</strong>
          <span>Intimate, magnetic &amp; compliment magnet</span>
        </div>
        <div class="quiz-option-card" onclick="calculateQuizResult('Executive')" style="grid-column: 1 / -1;">
          <div class="opt-icon"><i class="fa-solid fa-crown"></i></div>
          <strong>Executive &amp; Special Events</strong>
          <span>High projection &amp; unforgettable presence</span>
        </div>
      </div>
    `;
  }
}

function selectQuizOption(key, value, nextStep) {
  quizAnswers[key] = value;
  quizStep = nextStep;
  renderQuizStep();
}

function prevQuizStep() {
  if (quizStep > 1) {
    quizStep--;
    renderQuizStep();
  }
}

function calculateQuizResult(occasion) {
  quizAnswers.occasion = occasion;
  
  let matched = null;
  const { vibe, note } = quizAnswers;

  if (note === 'tea') matched = DOSSIER_PRODUCTS.find(p => p.id === 'blue-phantom');
  else if (note === 'pineapple') matched = DOSSIER_PRODUCTS.find(p => p.id === 'silver-birch');
  else if (note === 'apple_green') matched = DOSSIER_PRODUCTS.find(p => p.id === 'paris-oak');
  else if (note === 'pepper') matched = DOSSIER_PRODUCTS.find(p => p.id === 'shadow-noir');
  else if (note === 'verbena') matched = DOSSIER_PRODUCTS.find(p => p.id === 'woodland-enigma');
  else if (note === 'mint_incense') matched = DOSSIER_PRODUCTS.find(p => p.id === 'blue-nocturne');
  
  else if (note === 'bourbon_vanilla') matched = DOSSIER_PRODUCTS.find(p => p.id === 'orange-essence');
  else if (note === 'honey_tobacco') matched = DOSSIER_PRODUCTS.find(p => p.id === 'golden-citrus');
  else if (note === 'apple_vanilla') matched = DOSSIER_PRODUCTS.find(p => p.id === 'royal-lay');
  else if (note === 'tobacco_vanilla') matched = DOSSIER_PRODUCTS.find(p => p.id === 'tobacco-legend');
  
  else if (note === 'oud_sandalwood') matched = DOSSIER_PRODUCTS.find(p => p.id === 'dark-wood');
  else if (note === 'cinnamon_oud') matched = DOSSIER_PRODUCTS.find(p => p.id === 'red-egypt');
  else if (note === 'orris_sandalwood') matched = DOSSIER_PRODUCTS.find(p => p.id === 'reflected-sun');
  
  else if (note === 'saffron_amber') matched = DOSSIER_PRODUCTS.find(p => p.id === 'royal-inferno');
  else if (note === 'rum_amber') matched = DOSSIER_PRODUCTS.find(p => p.id === 'noble-blonde');
  
  else if (note === 'pear_hazelnut') matched = DOSSIER_PRODUCTS.find(p => p.id === 'floral-shade');
  else if (note === 'rose_patchouli') matched = DOSSIER_PRODUCTS.find(p => p.id === 'painting-red');
  
  // Fallbacks by vibe
  if (!matched) {
    if (vibe === 'Fresh') matched = DOSSIER_PRODUCTS.find(p => p.id === 'blue-phantom');
    else if (vibe === 'Amber') matched = DOSSIER_PRODUCTS.find(p => p.id === 'royal-inferno');
    else if (vibe === 'Woody') matched = DOSSIER_PRODUCTS.find(p => p.id === 'dark-wood');
    else if (vibe === 'Floral') matched = DOSSIER_PRODUCTS.find(p => p.id === 'floral-shade');
    else if (vibe === 'Gourmand') matched = DOSSIER_PRODUCTS.find(p => p.id === 'orange-essence');
    else matched = DOSSIER_PRODUCTS[0];
  }

  const container = document.getElementById('quizStepContainer');
  const title = document.getElementById('quizQuestionTitle');
  const backBtn = document.getElementById('quizBackBtn');

  if (backBtn) backBtn.style.display = 'none';
  if (title) title.innerHTML = `✨ We Found Your Perfect Match!`;

  if (container) {
    container.innerHTML = `
      <div class="quiz-result-card" style="text-align:center; padding:0.5rem 0;">
        <div style="margin-bottom:0.75rem;">
          <span class="badge-mini gold" style="border-radius:0; font-size:0.75rem; letter-spacing:0.06em; text-transform:uppercase;">99% SCENT MATCH</span>
        </div>
        
        <a href="/products/${matched.handle}" style="display:inline-block; margin-bottom:0.75rem;">
          <img src="${matched.image}" alt="${matched.title}" style="width:150px; height:150px; border-radius:0; margin:0 auto; object-fit:cover; box-shadow:var(--shadow-md); border:1px solid var(--color-border);">
        </a>

        <div style="font-size:0.8rem; font-weight:700; color:var(--color-accent-gold-dark, #b8860b); text-transform:uppercase; letter-spacing:0.05em; margin-bottom:0.25rem;">
          ${matched.vendor}
        </div>

        <h3 style="font-size:1.5rem; font-weight:800; margin-bottom:0.5rem; letter-spacing:-0.02em;">
          <a href="/products/${matched.handle}" style="color:inherit; text-decoration:none;">${matched.title}</a>
        </h3>

        <div style="display:flex; justify-content:center; align-items:center; gap:10px; margin-bottom:0.75rem;">
          <span style="font-size:1.5rem; font-weight:800; color:var(--color-sale-coral, #b91c1c);">$${matched.price.toFixed(2)}</span>
          <span style="font-size:1.1rem; text-decoration:line-through; color:var(--color-text-muted, #777);">$${matched.comparePrice.toFixed(2)}</span>
          <span class="save-pill" style="border-radius:0;">SAVE 90%+</span>
        </div>

        <div style="background:#f9f9f9; border:1px solid var(--color-border); padding:0.75rem 1rem; margin-bottom:1rem; text-align:left; font-size:0.82rem; line-height:1.5;">
          <div><strong>Top Notes:</strong> ${matched.notes ? matched.notes.top : 'Crisp Citrus, Sparkling Spices'}</div>
          <div style="margin:4px 0;"><strong>Heart Notes:</strong> ${matched.notes ? matched.notes.heart : 'Precious Florals, Spiced Wood'}</div>
          <div><strong>Base Notes:</strong> ${matched.notes ? matched.notes.base : 'Warm Amber, Cedarwood, Musk'}</div>
        </div>

        <p style="font-size:0.85rem; line-height:1.5; margin-bottom:1.25rem; color:#444;">${matched.description}</p>

        <div style="display:flex; flex-direction:column; gap:8px;">
          <button type="button" class="primary-btn w-full" style="padding:14px; font-weight:800; font-size:0.9rem; border-radius:0; background:#000; color:#fff;" onclick="addToCartAjax('${matched.variantId || matched.id}', 1); closeScentFinder();">
            <i class="fa-solid fa-bag-shopping"></i> ADD MATCH TO BAG — $${matched.price.toFixed(2)}
          </button>
          <div style="display:flex; gap:8px;">
            <a href="/products/${matched.handle}" class="secondary-btn" style="flex:1; text-align:center; padding:10px; text-decoration:none; font-size:0.85rem; border-radius:0;">
              VIEW DETAILS
            </a>
            <button type="button" class="secondary-btn" style="flex:1; padding:10px; font-size:0.85rem; border-radius:0;" onclick="openScentFinder()">
              <i class="fa-solid fa-rotate-right"></i> RETAKE QUIZ
            </button>
          </div>
        </div>
      </div>
    `;
  }
}

window.openScentFinder = openScentFinder;
window.closeScentFinder = closeScentFinder;
window.renderQuizStep = renderQuizStep;
window.selectQuizOption = selectQuizOption;
window.prevQuizStep = prevQuizStep;
window.calculateQuizResult = calculateQuizResult;

// ==========================================
// 6. VIP MODAL & REVIEWS CONTROLLER
// ==========================================
function openVipModal() {
  const modal = document.getElementById('vipModal');
  if (modal) modal.classList.add('active');
}

function closeVipModal() {
  const modal = document.getElementById('vipModal');
  if (modal) modal.classList.remove('active');
}

function handleVipForm(e) {
  e.preventDefault();
  closeVipModal();
  showToast("🎉 Welcome to Dossier+! Extra 10% OFF has been activated on your order.");
}

function subscribeVip() {
  const input = document.getElementById('vipEmailInput');
  if (!input || !input.value) {
    showToast("Please enter a valid email address.");
    return;
  }
  showToast("🎉 Welcome to Dossier+! Check your inbox for your 15% discount pass.");
  input.value = "";
}

function renderReviews(filterKeyword = 'all') {
  const grid = document.getElementById('reviewsGrid');
  if (!grid) return;

  const items = filterKeyword === 'all' 
    ? REVIEWS_DATA 
    : REVIEWS_DATA.filter(r => r.category.includes(filterKeyword) || r.title.includes(filterKeyword) || r.body.includes(filterKeyword));

  grid.innerHTML = items.map(r => `
    <div class="review-card">
      <div>
        <div class="review-top">
          <div class="stars-row">
            <i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i><i class="fa-solid fa-star"></i>
          </div>
          <span class="reviewer-badge"><i class="fa-solid fa-circle-check"></i> Verified Buyer</span>
        </div>
        <h4 class="review-title">${r.title}</h4>
        <p class="review-body">"${r.body}"</p>
      </div>
      <div class="review-product-tag">
        <img src="${r.productImg}" alt="${r.productName}">
        <span><strong>${r.author}</strong> &bull; Fragrance: ${r.productName}</span>
      </div>
    </div>
  `).join('');
}

function filterReviews(keyword) {
  document.querySelectorAll('.keyword-chip').forEach(chip => {
    if (chip.innerText.toLowerCase().includes(keyword.toLowerCase()) || (keyword === 'all' && chip.innerText.includes('All'))) {
      chip.classList.add('active');
    } else {
      chip.classList.remove('active');
    }
  });
  renderReviews(keyword);
}

// ==========================================
// 7. TOAST NOTIFICATIONS
// ==========================================
function showToast(message) {
  let container = document.getElementById('toastContainer');
  if (!container) {
    container = document.createElement('div');
    container.id = 'toastContainer';
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const toast = document.createElement('div');
  toast.className = 'toast';
  toast.innerHTML = `<i class="fa-solid fa-sparkles text-gold"></i> ${message}`;
  container.appendChild(toast);

  setTimeout(() => {
    toast.style.opacity = '0';
    toast.style.transform = 'translateY(10px)';
    setTimeout(() => toast.remove(), 300);
  }, 3500);
}
window.showToast = showToast;

// ==========================================
// 8. GLOBAL EVENT LISTENERS & INIT
// ==========================================
document.addEventListener('DOMContentLoaded', () => {
  renderProductGrid(DOSSIER_PRODUCTS);
  renderReviews('all');
  fetchShopifyCart();
  updateCartCounters();

  // Cart open/close triggers
  const cartToggleBtn = document.getElementById('cartToggleBtn');
  const closeCartBtn = document.getElementById('closeCartBtn');
  const cartOverlay = document.getElementById('cartOverlay');

  if (cartToggleBtn) cartToggleBtn.addEventListener('click', openCart);
  if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
  if (cartOverlay) {
    cartOverlay.addEventListener('click', (e) => {
      if (e.target === cartOverlay) closeCart();
    });
  }

  // Mobile nav triggers
  const mobileToggle = document.getElementById('mobileMenuToggle');
  const closeMobile = document.getElementById('closeMobileDrawer');
  const mobileDrawer = document.getElementById('mobileDrawer');
  const mobileOverlay = document.getElementById('mobileDrawerOverlay');
  if (mobileToggle) {
    mobileToggle.addEventListener('click', () => {
      if (mobileDrawer) mobileDrawer.classList.add('active');
      if (mobileOverlay) mobileOverlay.classList.add('active');
    });
  }
  if (closeMobile) {
    closeMobile.addEventListener('click', () => {
      if (mobileDrawer) mobileDrawer.classList.remove('active');
      if (mobileOverlay) mobileOverlay.classList.remove('active');
    });
  }

  // Desktop Header Dropdown Click Handlers (Click-to-toggle instead of hover)
  const navDropdownToggles = document.querySelectorAll('.has-megamenu > .nav-link, .about-dropdown-item > .about-link');
  
  function closeAllNavDropdowns() {
    document.querySelectorAll('.nav-item.is-open, .about-dropdown-item.is-open').forEach(el => {
      el.classList.remove('is-open');
      const btn = el.querySelector('.nav-link, .about-link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  navDropdownToggles.forEach(toggleBtn => {
    toggleBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const parent = toggleBtn.closest('.nav-item') || toggleBtn.closest('.about-dropdown-item');
      if (!parent) return;

      const isCurrentlyOpen = parent.classList.contains('is-open');
      closeAllNavDropdowns();

      if (!isCurrentlyOpen) {
        parent.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Close when clicking anywhere outside or pressing Escape
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.has-megamenu') && !e.target.closest('.about-dropdown-item')) {
      closeAllNavDropdowns();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllNavDropdowns();
    }
  });

  // AI Scent finder buttons
  const scentBtn = document.getElementById('openScentFinderBtn');
  if (scentBtn) scentBtn.addEventListener('click', openScentFinder);

  const vipBtn = document.getElementById('openVipModalBtn');
  if (vipBtn) vipBtn.addEventListener('click', openVipModal);

  // Interactive Header Search with Live Shopify Predictive Search
  const searchInput = document.getElementById('headerSearchInput') || document.getElementById('searchInput');
  const searchPopover = document.getElementById('predictiveSearchPopover');
  let searchDebounceTimer = null;

  if (searchInput && searchPopover) {
    searchInput.addEventListener('input', (e) => {
      const q = e.target.value.trim();
      clearTimeout(searchDebounceTimer);

      if (q.length < 2) {
        searchPopover.innerHTML = '';
        searchPopover.style.display = 'none';
        return;
      }

      searchDebounceTimer = setTimeout(() => {
        fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide`)
          .then(res => res.json())
          .then(data => {
            const products = data.resources?.results?.products || [];
            if (products.length === 0) {
              searchPopover.innerHTML = `<div class="predictive-no-results">No fragrances found for "${q}"</div>`;
              searchPopover.style.display = 'block';
              return;
            }

            let html = '';
            products.forEach(p => {
              const image = p.image ? `<img src="${p.image}" alt="${p.title}" class="predictive-thumb">` : `<div class="predictive-thumb"></div>`;
              const price = p.price ? `<span class="predictive-price">$${parseFloat(p.price).toFixed(2)}</span>` : '';
              html += `
                <a href="${p.url}" class="predictive-item">
                  ${image}
                  <div class="predictive-info">
                    <span class="predictive-title">${p.title}</span>
                    ${price}
                  </div>
                </a>
              `;
            });

            html += `<a href="/search?q=${encodeURIComponent(q)}" class="predictive-view-all">View all results for "${q}" &rarr;</a>`;
            searchPopover.innerHTML = html;
            searchPopover.style.display = 'block';
          })
          .catch(() => {
            searchPopover.style.display = 'none';
          });
      }, 250);
    });

    // Close on click outside or Escape
    document.addEventListener('click', (e) => {
      if (!searchInput.contains(e.target) && !searchPopover.contains(e.target)) {
        searchPopover.style.display = 'none';
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        searchPopover.style.display = 'none';
      }
    });
  }

  // Category filter pills click listeners
  document.querySelectorAll('.filter-pill').forEach(pill => {
    pill.addEventListener('click', () => {
      filterCatalog(pill.dataset.filter);
    });
  });

  // Carousel slider navigation (Desktop & Mobile)
  const carouselTrack = document.getElementById('latestCarouselTrack');
  const prevBtn = document.getElementById('latestPrevBtn');
  const nextBtn = document.getElementById('latestNextBtn');
  const mobPrevBtn = document.getElementById('latestMobilePrev');
  const mobNextBtn = document.getElementById('latestMobileNext');
  const dotsContainer = document.getElementById('latestDotsTrack');

  function scrollCarousel(amount) {
    if (carouselTrack) {
      carouselTrack.scrollBy({ left: amount, behavior: 'smooth' });
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', () => scrollCarousel(-320));
  if (nextBtn) nextBtn.addEventListener('click', () => scrollCarousel(320));
  if (mobPrevBtn) mobPrevBtn.addEventListener('click', () => scrollCarousel(-270));
  if (mobNextBtn) mobNextBtn.addEventListener('click', () => scrollCarousel(270));

  // Sync mobile dots with scroll position
  if (carouselTrack && dotsContainer) {
    const dots = dotsContainer.querySelectorAll('.dot');
    carouselTrack.addEventListener('scroll', () => {
      const scrollLeft = carouselTrack.scrollLeft;
      const cardWidth = 270;
      const activeIdx = Math.min(Math.round(scrollLeft / cardWidth), dots.length - 1);
      dots.forEach((d, i) => {
        d.classList.toggle('active', i === activeIdx);
      });
      if (mobPrevBtn) mobPrevBtn.style.color = scrollLeft > 20 ? '#111111' : '#cccccc';
    }, { passive: true });
  }

  // Live Sale Countdown Timer Ticker
  let hours = 18, mins = 42, secs = 30;
  setInterval(() => {
    secs--;
    if (secs < 0) { secs = 59; mins--; }
    if (mins < 0) { mins = 59; hours--; }
    if (hours < 0) { hours = 23; }

    const hEl = document.getElementById('countHours');
    const mEl = document.getElementById('countMinutes');
    const sEl = document.getElementById('countSeconds');

    if (hEl) hEl.innerText = hours < 10 ? `0${hours}` : hours;
    if (mEl) mEl.innerText = mins < 10 ? `0${mins}` : mins;
    if (sEl) sEl.innerText = secs < 10 ? `0${secs}` : secs;
  }, 1000);
});

// Perfume House Multi-Slide Carousel Controller
let currentHouseSlide = 0;

function setHouseSlide(index) {
  const container = document.getElementById('perfumeHouseCarousel');
  if (!container) return;
  const slides = container.querySelectorAll('.house-slide');
  const dots = container.querySelectorAll('.house-dot');
  if (!slides.length) return;

  currentHouseSlide = (index + slides.length) % slides.length;

  slides.forEach((slide, idx) => {
    slide.classList.toggle('active', idx === currentHouseSlide);
  });

  dots.forEach((dot, idx) => {
    dot.classList.toggle('active', idx === currentHouseSlide);
  });
}

function switchHouseSlide(direction) {
  setHouseSlide(currentHouseSlide + direction);
}

window.setHouseSlide = setHouseSlide;
window.switchHouseSlide = switchHouseSlide;

// ==========================================
// 3D DEPTH-PARALLAX HERO GLOBAL CONTROLLER
// ==========================================
function init3DParallaxHero() {
  const wrappers = document.querySelectorAll('.luxury-3d-hero-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach(wrapper => {
    const stage = wrapper.querySelector('.hero-3d-stage');
    const track = wrapper.querySelector('.hero-horizontal-track');
    if (!stage || !track) return;

    const panels = Array.from(wrapper.querySelectorAll('.hero-panel-slide'));
    const totalPanels = panels.length;
    if (totalPanels === 0) return;

    const currentSlideEl = wrapper.querySelector('.current-slide');
    const indicatorBtns = Array.from(wrapper.querySelectorAll('.hud-progress-dash'));

    let mouseTargetX = 0, mouseTargetY = 0;
    let mouseCurrentX = 0, mouseCurrentY = 0;
    const lerpFactor = 0.07;

    const panelData = panels.map(panel => ({
      bg: panel.querySelector('.layer-bg-media'),
      giantWord: panel.querySelector('.giant-display-word'),
      flacon: panel.querySelector('.cutout-shadow-anchor'),
      card: panel.querySelector('.editorial-card')
    }));

    window.addEventListener('mousemove', (e) => {
      mouseTargetX = (e.clientX / window.innerWidth) - 0.5;
      mouseTargetY = (e.clientY / window.innerHeight) - 0.5;
    }, { passive: true });

    indicatorBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        const idx = parseInt(btn.getAttribute('data-target-index'), 10) || 0;
        const wrapperRect = wrapper.getBoundingClientRect();
        const scrollDistance = wrapper.offsetHeight - stage.offsetHeight;
        const targetScrollY = window.scrollY + wrapperRect.top + (idx / (totalPanels - 1)) * scrollDistance;
        window.scrollTo({ top: targetScrollY, behavior: 'smooth' });
      });
    });

    function updateParallax() {
      mouseCurrentX += (mouseTargetX - mouseCurrentX) * lerpFactor;
      mouseCurrentY += (mouseTargetY - mouseCurrentY) * lerpFactor;

      const wrapperRect = wrapper.getBoundingClientRect();
      const scrollDistance = wrapper.offsetHeight - stage.offsetHeight;

      let progress = 0;
      if (scrollDistance > 0) {
        const rawProg = -wrapperRect.top / scrollDistance;
        progress = Math.max(0, Math.min(1, rawProg)) * (totalPanels - 1);
      }

      const activeIndex = Math.round(progress);
      if (currentSlideEl) {
        currentSlideEl.innerText = (activeIndex + 1 < 10 ? '0' : '') + (activeIndex + 1);
      }

      indicatorBtns.forEach((btn, i) => {
        btn.classList.toggle('active', i === activeIndex);
      });

      const isMobile = window.innerWidth <= 768;

      if (isMobile) {
        track.style.transform = `translate3d(0, ${-progress * 100}vh, 0)`;
      } else {
        track.style.transform = `translate3d(${-progress * 100}vw, 0, 0)`;
      }

      for (let i = 0; i < totalPanels; i++) {
        const u = progress - i;
        const absU = Math.abs(u);
        const pItem = panelData[i];
        if (!pItem) continue;

        if (absU > 1.4) {
          if (pItem.card) pItem.card.style.opacity = '0';
          continue;
        }

        const centerFactor = Math.max(0, 1 - absU);

        if (pItem.bg) {
          const bgShiftX = u * 7 + (mouseCurrentX * 2);
          const bgScale = 1.05 + (centerFactor * 0.08);
          pItem.bg.style.transform = `translate3d(${bgShiftX}vw, ${mouseCurrentY * 2}vh, 0) scale(${bgScale})`;
        }

        if (pItem.giantWord) {
          const wordShiftX = (-u * 34) + (mouseCurrentX * 5.5);
          const wordScale = 1 + (centerFactor * 0.05);
          const wordOpacity = Math.max(0, 1 - (absU * 0.95));
          pItem.giantWord.style.transform = `translate3d(${wordShiftX}vw, ${mouseCurrentY * 3}vh, 0) scale(${wordScale})`;
          pItem.giantWord.style.opacity = wordOpacity.toString();
        }

        if (pItem.flacon) {
          const flaconShiftX = (-u * 12) + (mouseCurrentX * 3.2);
          const flaconShiftY = (mouseCurrentY * 2.8);
          const flaconScale = 1 + (centerFactor * 0.04);
          pItem.flacon.style.transform = `translate3d(${flaconShiftX}vw, ${flaconShiftY}vh, 0) scale(${flaconScale})`;
        }

        if (pItem.card) {
          const cardOpacity = Math.max(0, 1 - (absU * 1.8));
          const cardShiftY = (u * 28);
          pItem.card.style.opacity = cardOpacity.toString();
          pItem.card.style.transform = `translate3d(0, ${cardShiftY}px, 0)`;
        }
      }

      requestAnimationFrame(updateParallax);
    }

    requestAnimationFrame(updateParallax);
  });
}

document.addEventListener('DOMContentLoaded', init3DParallaxHero);
window.init3DParallaxHero = init3DParallaxHero;
